import type { ReactNode } from "react";
import {
  Alert,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
  type SxProps,
  type Theme,
} from "@mui/material";

export const LARGE_UPLOADED_CSV_TEXT_LIMIT = 20_000;

export const compactTableSx = {
  "& th": {
    backgroundColor: "action.hover",
    color: "text.secondary",
    fontWeight: 800,
    letterSpacing: 0,
    py: 0.75,
    textTransform: "uppercase",
  },
  "& td": {
    borderColor: "divider",
    py: 0.75,
    verticalAlign: "top",
  },
} as const;

export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const WorkflowCard = ({
  title,
  children,
  sx,
  contentSx,
  bodySx,
}: {
  title: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
  bodySx?: SxProps<Theme>;
}) => {
  return (
    <Card variant="outlined" sx={{ flex: 1, minWidth: 0, ...sx }}>
      <CardContent sx={contentSx}>
        <Stack spacing={2} sx={bodySx}>
          <Typography variant="h6">{title}</Typography>
          {children}
        </Stack>
      </CardContent>
    </Card>
  );
};

export const MetricChip = ({ label, value }: { label: string; value: string | number }) => {
  return <Chip variant="outlined" size="small" label={`${label}: ${value}`} />;
};

export const StageUnavailable = ({ message }: { message: string }) => {
  return (
    <Alert severity="info" variant="outlined" sx={{ alignItems: "center" }}>
      {message}
    </Alert>
  );
};
